import React from "react"
import Modal from "aldoo-ra/Modal"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { url as cmsUrl } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

export default function SigninSuccessDialog({ controller }) {
  const { closeDialog, loginConfirm, userProfile, DialogType, isDialogOpen } =
    controller

  return (
    <Modal
      isOpen={isDialogOpen(DialogType.SUCCESS)}
      onClose={closeDialog}
      allowCloseBtn={false}
      variant="aqua_medium"
      className="max-w-[534px]"
    >
      <CMSRender
        contentType="SigninSuccessDialog"
        renderItem={(dialog) => {
          return (
            <div className="flex flex-col w-full items-center justify-center gap-6 bg-theme_white mx-auto">
                {/* Title */}
                <Typography 
                  variant="h3" 
                  className="text-center"
                >
                  {dialog.title}
                </Typography>

                {/* User Avatar */}
                <div className="w-24 h-24 rounded-full bg-theme_white overflow-hidden">
                  {userProfile?.avatar ? (
                    <img
                      src={cmsUrl(userProfile.avatar)}
                      alt={userProfile.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-theme_white">
                      <img
                        src={dialog.icon}
                        alt="Default profile"
                        className="w-24 h-24"
                      />
                    </div>
                  )}
                </div>

                {/* User Name */}
                {userProfile?.name && (
                  <Typography 
                    variant="subtitle_30_accent"
                    className="text-text my-0"
                  >
                    {userProfile.name}
                  </Typography>
                )}

                {/* User Email */}
                {userProfile?.email && (
                  <Typography 
                    variant="info_16"
                    className="text-gray_1 my-0"
                  >
                    {userProfile.email}
                  </Typography>
                )}

                {/* Continue Button */}
                <Button
                  variant="primary"
                  onClick={loginConfirm}
                  className="!w-[240px] mt-6 mx-auto"
                >
                  {dialog.continue}
                </Button>
            </div>
          )
        }}
      />
    </Modal>
  )
}
